import React from 'react'
import { withRouter } from 'react-router-dom';
import OutpatientList from "../../../component/sysadmin/outpatient/outpatient_list";
import OutpatientListSearch from "../../../component/sysadmin/outpatient/outpatient_list_search";

class OutpatientListPage extends React.Component {

    render() {
        return (
            <>
                <OutpatientListSearch />
                <OutpatientList />
            </>
        )
    }

}

export default withRouter(OutpatientListPage);